module.exports = __webpack_public_path__ + "media/images/logo/gigbase-sol_logo-346a216d274e7f038932a44dde91314d.svg";